import { CheckoutDetailsFormData } from '../../../../entities/@forms/Checkout/Checkout';
import {
    FormErrors,
    FormValidation,
    validateDutchPostalCode,
    validateEmailAddress,
    validateForm, validatePhoneNumber,
    validateRequiredString,
} from '../../../../entities/@forms/FormValidation/FormValidationService';

export type CheckoutDetailsFormErrors = FormErrors<CheckoutDetailsFormData>;

export const validateCheckoutDetailsFormData = (formData: CheckoutDetailsFormData): FormValidation<CheckoutDetailsFormErrors> => {
    const password = formData.createAccount
        ? validateRequiredString('password', formData.password)
        : undefined;

    const errors: CheckoutDetailsFormErrors = {
        firstName: validateRequiredString('firstName', formData.firstName),
        lastName: validateRequiredString('lastName', formData.lastName),
        email: validateEmailAddress(formData.email),
        phoneNumber: validatePhoneNumber(formData.phoneNumber),
        shippingStreet: validateRequiredString('street', formData.shippingStreet),
        shippingHouseNumber: validateRequiredString('houseNumber', formData.shippingHouseNumber),
        shippingPostalCode: validateDutchPostalCode(formData.shippingPostalCode),
        shippingCity: validateRequiredString('city', formData.shippingCity),
        billingStreet: validateRequiredString('street', formData.billingStreet),
        billingHouseNumber: validateRequiredString('houseNumber', formData.billingHouseNumber),
        billingPostalCode: validateDutchPostalCode(formData.billingPostalCode),
        billingCity: validateRequiredString('city', formData.billingCity),
        password,
    };

    return validateForm<CheckoutDetailsFormErrors>(errors);
};
